import React from 'react';
import cx from 'classnames';
import { PRACTICE_CHARACTERIZATION_EVALUATION_VALUES } from '../../../shared/constants/practice-characterization-evaluation-values';

/**
 * @typedef {object} ReportTablePracticeCellProps
 * @property {Object} [practiceArea]
 * @property {Object} [practice]
 * @property {boolean} isSelected
 * @property {(selected: { practiceArea: Object, practice: Object }) => void} handleSelected
 * @property {boolean} isLastPracticeInGroup
 */

/**
 * @param {ReportTablePracticeCellProps} props
 */
export const ReportTablePracticeCell = props => {
  const { practiceArea, practice, isLastPracticeInGroup, isSelected, handleSelected } = props;

  const value = practice.characterizationEvaluation;
  const cellClassName = cx({
    'report-table__border-right': isLastPracticeInGroup,
    'report-table__cell--not-available':
      value === PRACTICE_CHARACTERIZATION_EVALUATION_VALUES.UNAVAILABLE,
    'report-table__cell--centered':
      value === PRACTICE_CHARACTERIZATION_EVALUATION_VALUES.SATISFIED ||
      value === PRACTICE_CHARACTERIZATION_EVALUATION_VALUES.PARTIAL ||
      value === PRACTICE_CHARACTERIZATION_EVALUATION_VALUES.DEFICIENT,
    'report-table__cell--green': value === PRACTICE_CHARACTERIZATION_EVALUATION_VALUES.SATISFIED,
    'report-table__cell--yellow': value === PRACTICE_CHARACTERIZATION_EVALUATION_VALUES.PARTIAL,
    'report-table__cell--red': value === PRACTICE_CHARACTERIZATION_EVALUATION_VALUES.DEFICIENT,
    'selected-satisfied':
      isSelected && value === PRACTICE_CHARACTERIZATION_EVALUATION_VALUES.SATISFIED,
    'selected-partial': isSelected && value === PRACTICE_CHARACTERIZATION_EVALUATION_VALUES.PARTIAL,
    'selected-deficient':
      isSelected && value === PRACTICE_CHARACTERIZATION_EVALUATION_VALUES.DEFICIENT
  });

  if (value === PRACTICE_CHARACTERIZATION_EVALUATION_VALUES.NOT_SET) {
    return <td className={cellClassName} />;
  }

  if (value === PRACTICE_CHARACTERIZATION_EVALUATION_VALUES.UNAVAILABLE) {
    return <td className={cellClassName} />;
  }

  return (
    <td
      className={cellClassName}
      onClick={e => {
        e.stopPropagation();
        handleSelected({
          practiceArea: practiceArea,
          practice: practice
        });
      }}>
      {value}
    </td>
  );
};
